import { defineFcm } from '../shared/factory';

export const FCM_ALLOW_IDENTIFIED_USER_FETCH_PETITION_LISTS = defineFcm('allow_identified_user_fetch_petition_lists')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-site-platform',
		scope: 'corgi-middle-end',
		context: 'User Profile',
		description:
			'If true, the current user can see their signed and started petitions even if they are only identified.',
		import: false,
	});
